import * as Types from '../../../declarations'
import { ActionIcon } from '@mantine/core'
import { IconPencil } from '@tabler/icons-react'
import * as AppStore from './../../../state/app-store'
import * as Actions from './../../../state/actions'
// import { useIsMobile } from '../../../lib/useIsMobile'

interface Props {
	title: string
	subtitle?: string
	section: Types.App.DataTypes.FeedbackSection
}

const SectionHeader = ({ title, subtitle, section }: Props) => {
	// const isMobile = useIsMobile()

	const dispatch = AppStore.useAppDispatch()

	const openEdit = () => dispatch(Actions.openSuggestFeedbackModal(section))

	return (
		<div className="section-title">
			<div className="titles-section">
				<h2>
					<a id={section.toLowerCase()} href={`#${section.toLowerCase()}`}>
						{title}
					</a>
				</h2>
				{!!subtitle && <h3>{subtitle}</h3>}
			</div>
			<ActionIcon onClick={openEdit}>
				<IconPencil aria-label={`edit ${title}`} />
			</ActionIcon>
		</div>
	)
}

export default SectionHeader
